module.exports = __webpack_public_path__ + "img/ruihong_08.04b942a6.jpg";